"use client";

import React from "react";
import { HiArrowLongRight } from "react-icons/hi2";
import { motion } from "framer-motion";

const Card = ({
  title,
  description,
  className,
  arrowClassName,
  cardColSpan,
  children,
}) => {
  return (
    <motion.div
      className={`absolute ${className}`}
      initial={{ opacity: 0 }}
      whileInView={{
        opacity: 1,
      }}
      transition={{
        duration: 0.5,
        delay: 1,
        ease: "easeInOut",
      }}
      viewport={{ once: true }}
    >
      <div
        className={`relative flex flex-col justify-between items-start min-h-40 md:min-h-52 gap-5 px-5 py-6 rounded-2xl bg-white text-black shadow-lg ${cardColSpan}`}
      >
        <div className="flex flex-col gap-0">
          <div className="text-lg font-bold">{title}</div>
          <div
            className="text-sm font-normal leading-loose"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
        {arrowClassName && (
          <HiArrowLongRight
            className={`absolute ${arrowClassName} text-white text-2xl`}
            size={100}
          />
        )}
        {children}
      </div>
    </motion.div>
  );
};

const LangkahStrategis = () => {
  return (
    <div className="relative flex flex-col justify-start items-center h-[calc(180vh)] sm:h-[calc(160vh+80px)] md:h-[calc(120vh+80px)] lg:h-[calc(150vh+80px)] xl:h-[calc(100vh+80px)] 2xl:h-[calc(100vh+80px)] gap-7 md:gap-12 px-5 sm:px-10 md:px-16 py-7 sm:py-12 md:py-20 bg-[url('/image/bg-peran-kementerian.webp')] bg-cover bg-center bg-no-repeat overflow-hidden">
      <div className="absolute inset-0 bg-[#1E1D1DDE] z-0" />
      <motion.div
        className="text-2xl sm:text-4xl md:text-5xl font-bold w-full z-10 text-white text-center md:text-left"
        initial={{ x: 50, opacity: 0 }}
        whileInView={{
          x: 0,
          opacity: 1,
        }}
        transition={{
          duration: 0.5,
          delay: 1,
          ease: "easeInOut",
        }}
        viewport={{ once: true }}
      >
        Langkah Strategis Penguatan Produk Lokal
      </motion.div>

      <div className="relative w-full h-full z-10">
        <Card
          title="Penguatan Kapasitas SDM"
          description="Fasilitasi Pelatihan & Pendampingan, serta Peningkatan kapasitas digitalisasi"
          className="top-0 left-0"
          arrowClassName="rotate-90 md:rotate-0 right-1/2 md:-right-20 -bottom-20 md:top-1/2 translate-x-1/2 md:translate-x-0 translate-y-0 md:-translate-y-1/2"
          cardColSpan="w-[calc(100vw/1-40px)] sm:w-[calc(100vw/1-80px)] md:w-[calc(100vw/2-104px)] xl:w-[calc(100vw/3-96px)]"
        >
          <Card
            title="Peningkatan Kualitas & Daya Saing Produk"
            description="Sertifikasi & standardisasi produk, mendorong inovasi produk, dan melakukan R&D bersama BRIN dan instansi terkait lainnya untuk meningkatkan keunggulan kompetitif"
            className="top-full md:top-0 left-0 md:left-full translate-y-[80px] md:translate-y-0 translate-x-0 md:translate-x-[80px]"
            arrowClassName="rotate-90 xl:rotate-0 right-1/2 xl:-right-20 -bottom-20 xl:top-1/2 translate-x-1/2 xl:translate-x-0 translate-y-0 xl:-translate-y-1/2"
            cardColSpan="w-[calc(100vw/1-40px)] sm:w-[calc(100vw/1-80px)] md:w-[calc(100vw/2-104px)] xl:w-[calc(100vw/3-96px)]"
          >
            <Card
              title="Perluasan Akses Pembiayaan dan Integrasi"
              description="Isu Strategis: <br/>
                <ul class='list-disc pl-5 text-sm font-normal leading-loose'>
                <li>Kurangnya insentif pemerintah terhadap pembiayaan UKM. Pembiayaan masih banyak ditujukan untuk Usaha Mikro.</li>
                <li>Tingginya suku bunga pada alternatif pembiayaan lain (P2P Lending, Securities Crowdfunding, Moda Ventura)</li>
                <li>Partisipasi kemitraan UMKM Indonesia dengan rantai produksi global (GVC) masih kecil (4,1%) dibandingkan negara Asia Tenggara lainnya</li>
                </ul>"
              className="top-full xl:top-0 left-0 xl:left-full translate-y-[80px] xl:translate-y-0 translate-x-0 xl:translate-x-[80px]"
              arrowClassName={
                "rotate-90 md:rotate-180 xl:rotate-90 -bottom-20 md:bottom-1/2 xl:-bottom-20 right-1/2 md:-left-20 xl:left-1/2 translate-y-0 md:-translate-y-1/2 lg:translate-y-1/2 xl:translate-y-0  translate-x-1/2 md:translate-x-0 xl:-translate-x-1/2"
              }
              cardColSpan="w-[calc(100vw/1-40px)] sm:w-[calc(100vw/1-80px)] md:w-[calc(100vw/2-104px)] xl:w-[calc(100vw/3-96px)]"
            >
              <Card
                title="Perluasan Kemitraan, Rantai Pasok, dan Pemasaran"
                description="Melalui platform SMESTA, Business Matching, perkuat jaringan Diaspora, Pemasaran Digital dan Promosi Internasional melalui Pameran dan Forum-Forum Internasional"
                className="top-full md:top-0 xl:top-full right-0 md:right-full xl:left-0 translate-x-0 md:-translate-x-[80px] xl:translate-x-0 translate-y-[80px] md:translate-y-0 xl:translate-y-[80px]"
                arrowClassName={
                  "rotate-90 xl:rotate-180 -bottom-20 xl:top-1/2 translate-y-0 xl:-translate-y-1/2 left-1/2 xl:-left-20 -translate-x-1/2 xl:translate-x-0"
                }
                cardColSpan="w-[calc(100vw/1-40px)] sm:w-[calc(100vw/1-80px)] md:w-[calc(100vw/2-104px)] xl:w-[calc(100vw/3-96px)]"
              >
                <Card
                  title="Dukungan Pemerintah Lainnya"
                  description="KONSOLIDASI PRODUK dalam satu kategori ekspor untuk menekan biaya logistic (Holding UMKM)"
                  className="top-full xl:top-0 right-0 xl:right-full translate-x-0 xl:-translate-x-[80px] translate-y-[80px] xl:translate-y-0"
                  cardColSpan="w-[calc(100vw/1-40px)] sm:w-[calc(100vw/1-80px)] md:w-[calc(100vw/2-104px)] xl:w-[calc(100vw/3-96px)]"
                />
              </Card>
            </Card>
          </Card>
        </Card>
      </div>
    </div>
  );
};

export default LangkahStrategis;
